import axios from "axios"

const server = process.env.REACT_APP_SERVER_URL

export const fetchUnits = async (): Promise<IUnit[]> => {
  try {
    const response = await axios.get< {unitTypes: {abbreviatedName: string, id: string, name: string}[]} >(`${server}/config/unit`)
    return response?.data?.unitTypes
  } catch (error) {
    throw error
  }
}

interface IUnitsResponse {
  status: number
  units: IUnit[]
}

export interface IUnit {
  id: string
  name: string
  abbreviatedName: string
}